import Bubble from 'components/bubble';
import CTA from 'components/Campaign/CTA';
import PropTypes from 'prop-types';

export default function Springboard({
  keyword = 'resist',
  message = 'Introduce yourself!',
}) {
  const keywordUpper = keyword.toUpperCase();
  return (
    <>
      <h1 className="mb-2 text-center">{message}</h1>

      <div className="card-flat p-8">
        <ol className="mx-auto list-decimal divide-y">
          <li className="py-2">
            <p className="mb-2">
              Tap here to get started (or text <Bubble>{keyword}</Bubble> to
              50409.)
            </p>
            <CTA keyword={keywordUpper} />
          </li>

          <li className="py-2">
            <p>Send the text to the app of your choice</p>
          </li>

          <li className="py-2">
            <p>Read the texts that come back and follow the directions!</p>
          </li>
        </ol>
      </div>
    </>
  );
}

Springboard.propTypes = {
  keyword: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};
